import { ValidationStrategy } from "./validation.strategy";

export class CalendarValidationStrategy extends ValidationStrategy {
    public validate(): boolean {
        let isValid = true;

        if (this.isRequired && !this.isDisabled && !this.isHidden) {
            isValid = false;

            const selectedItemsAttr = this.attribute.attributes
                .find(attr => attr.key.toLowerCase() == "selected items");

            isValid = selectedItemsAttr != null && selectedItemsAttr.attributes.length > 0;
        }

        return isValid
    }
}